'use strict'

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

Vue.use(VueRouter)

const routes = [
   {
      path: '/start',
      name: 'Start',
      component: () => import(/* webpackChunkName: "start" */ './routeComponents/Start.vue'),
      meta: { authNotAllowed: true }
   },
   {
      path: '/sign-in',
      name: 'SignIn',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "sign-in" */ './routeComponents/SignIn.vue'),
      meta: { authNotAllowed: true }
   },
   {
      path: '/user/settings',
      name: 'Settings',
      component: () => import(/* webpackChunkName: "settings" */ './routeComponents/User/Settings.vue'),
      meta: { requiresAuth: true }
   },
   {
      path: '/:companySlug/manage',
      name: 'CompanyAdmin_Manage',
      component: () => import(/* webpackChunkName: "companyAdmin-manage" */ './routeComponents/[company]/Manage.vue'),
      meta: { requiresAuth: true }
   },
   {
      path: '/:companySlug/:teamSlug/manage',
      name: 'TeamAdmin_Manage',
      component: () => import(/* webpackChunkName: "teamAdmin-manage" */ './routeComponents/[company][team]/Manage.vue'),
      meta: { requiresAuth: true }
   },
   {
      path: '/:companySlug/:teamSlug/edit',
      name: 'TeamAdmin_EditProfile',
      component: () => import(/* webpackChunkName: "teamAdmin-manage" */ './routeComponents/[company][team]/ProfileEdit.vue'),
      meta: { requiresAuth: true }
   },
   {
      path: '/add-team/step-1',
      name: 'AddTeam_Step1',
      component: () => import(/* webpackChunkName: "teamAdmin-manage" */ './routeComponents/AddTeam/Step-1'),
      meta: { requiresAuth: true }
   },
   {
      path: '/add-team/step-2',
      name: 'AddTeam_Step2',
      component: () => import(/* webpackChunkName: "teamAdmin-manage" */ './routeComponents/AddTeam/Step-2'),
      meta: { requiresAuth: true }
   },
   {
      path: '/add-team/plane',
      name: 'AddTeam_Plan',
      component: () => import(/* webpackChunkName: "teamAdmin-manage" */ './routeComponents/AddTeam/Plan'),
      meta: { requiresAuth: true }
   }
]

const router = new VueRouter({
   mode: 'history',
   base: process.env.BASE_URL,
   routes
})

router.beforeEach((to, from, next) => {
   let initPromises = []
   if (!store.state.isAuthenticated) {
      initPromises.push(store.dispatch('onAppInit'))
   }

   return Promise.all(initPromises).then(() => {
      // Note: `next()` has to be called in order to continue route execution.
      // See https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards

      if (!to.name) next('/sign-in')
      else if (to.matched.some(record => record.meta.requiresAuth)) {
         // On why `to.matched.some` is necessary: https://router.vuejs.org/guide/advanced/meta.html#route-meta-fields
         if (!store.state.isAuthenticated) next('/sign-in')
         else {
            let maybeInitAccount
            if (!store.state.makerState.teams) {
               console.log('getting teams from fauna.....')
               maybeInitAccount = store.dispatch('loadMakerAccount')
            }
            return Promise.resolve(maybeInitAccount).then(next)
         }
      } else {
         if (to.path === '/') next('/sign-in')
         else if (!store.state.isAuthenticated) next()
         // Make the user settings view default
         else if (!to.matched.length || to.matched.some(record => record.meta.authNotAllowed)) next('/user/settings')
         else next()
      }
   })
})

export default router
